<script lang="ts" setup>
import type { BaseContentResponseModel, RelatedBlogsComponentModel } from '@su4r-frontend/api';

const { data } = defineProps<{
    data: BaseContentResponseModel;
}>();

useSeoMeta({
    title: () => data.metaInformation?.metaTitle ?? 'Blog',
    ogTitle: () => data.metaInformation?.metaTitle ?? 'Blog',
    description: () => data.metaInformation?.metaDescription,
    ogDescription: () => data.metaInformation?.metaDescription,
    ogImage: () => data.metaInformation?.imageUrl,
    ogImageAlt: () => data.metaInformation?.metaTitle,
});

const relatedBlogsComponent = data?.components?.find(
    (comp) => comp.alias === 'relatedBlogsComponent'
) as RelatedBlogsComponentModel;
</script>

<template>
    <section>
        <div class="container grid gap-y-0 lg:gap-y-0">
            <template
                v-for="(component, index) in data?.components?.filter(
                    (comp) => comp.alias !== 'relatedBlogsComponent'
                )"
                :key="`${component.alias}-${index}`">
                <component
                    :is="mapComponentAlias(component.alias ?? '')"
                    v-bind="{ ...component }" />
            </template>
        </div>

        <div
            v-if="relatedBlogsComponent?.blogs?.length > 0"
            class="container grid gap-y-0 lg:gap-y-0">
            <RelatedBlogs class="mt-4 lg:col-span-12 lg:mt-6" v-bind="relatedBlogsComponent" />
        </div>
    </section>
</template>
